import { render, staticRenderFns } from "./ResetPasswordBody.vue?vue&type=template&id=b8659d04&scoped=true"
import script from "./ResetPasswordBody.vue?vue&type=script&lang=js"
export * from "./ResetPasswordBody.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordBody.vue?vue&type=style&index=0&id=b8659d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8659d04",
  null
  
)

export default component.exports